import React from "react";
import { useSelector } from "react-redux";
import { REORDERING } from "ui/pages/TemplatePreview/constants";
import BasicType from "./BasicType";
import ListingType from "./ListingType";
import KeywordType from "./KeywordType";
import { Customizations } from "features/ManageWebpage/modules/Customizations/Customizations";

const ListingReordering = (props) => {
  const selected_reordering_type = useSelector(
    (state) => state.webpage_detail.selected_reordering_type
  );

  switch (selected_reordering_type) {
    case REORDERING.basic_type: {
      return <BasicType />;
    }
    case REORDERING.lisitng_type: {
      return <ListingType />;
    }
    case REORDERING.keyword_type: {
      return <KeywordType />;
    }
    default: {
      return <Customizations {...props} />;
    }
  }
};

export default ListingReordering;
